module.exports = __webpack_public_path__ + "static/media/icon_growth.c5afac38.svg";